import React from 'react';

import { margin, useClassnames } from '@lumapps/classnames';
import { DetailedDirectoryEntryBlock } from '@lumapps/directories-entries/components/DetailedDirectoryEntryBlock/DetailedDirectoryEntryBlock';
import { DetailedDirectoryEntryVariant } from '@lumapps/directories-entries/types';
import { lumappsMicroApp } from '@lumapps/lumx/custom-icons';
import { mdiLinkVariant } from '@lumapps/lumx/icons';
import { ColorPalette } from '@lumapps/lumx/react';

import { AskAiDirectoryEntryType, DirectoryEntryBestAnswer } from '../../../types';

const CLASSNAME = 'ask-ai-directory-entry-card';

export interface AskAiDirectoryEntryCardProps {
    /** payload for the directory entry */
    directoryEntry: DirectoryEntryBestAnswer;
    /** custom classname */
    className?: string;
}

/**
 * Display the given directory entry card if a directory entry object is returned in the best answer.
 */
export const AskAiDirectoryEntryCard = ({ directoryEntry, className }: AskAiDirectoryEntryCardProps) => {
    const { block } = useClassnames(CLASSNAME);
    const { id, directoryId, resourceId, description, tags, metadata, name, directoryEntryType, url, thumbnail } =
        directoryEntry;

    const isMicroApp = directoryEntryType === AskAiDirectoryEntryType.DIRECTORY_ENTRY_MICROAPP && Boolean(resourceId);

    return (
        <DetailedDirectoryEntryBlock
            directoryEntryId={id}
            directoryId={directoryId}
            link={url}
            title={name}
            isFavoriteIconVisible={false}
            isFavorite={false}
            variant={DetailedDirectoryEntryVariant.vertical}
            directoryEntryType={isMicroApp ? 'microapp' : 'link'}
            resourceId={resourceId}
            badgeProps={{ icon: isMicroApp ? lumappsMicroApp : mdiLinkVariant, color: ColorPalette.grey }}
            image={thumbnail ? { url: thumbnail, alt: '' } : undefined}
            classname={block([margin('vertical', 'huge'), className])}
            additionalFields={
                description
                    ? [
                          {
                              id,
                              values: [description],
                          },
                      ]
                    : undefined
            }
            tags={tags}
            metadata={metadata}
            titleAs="p"
        />
    );
};
